import { useEffect } from 'react';
import { X, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

interface PartnerInquiryModalProps {
  onClose: () => void;
}

export function PartnerInquiryModal({ onClose }: PartnerInquiryModalProps) {
  // Lock body scroll when modal is open
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);
  const { t } = useLanguage();

  const handleEmailClick = () => {
    const subject = encodeURIComponent(t('partnerInquiryEmailSubject'));
    const body = encodeURIComponent(t('partnerInquiryEmailBody'));
    
    window.location.href = `mailto:peter@tugedr.com?subject=${subject}&body=${body}`;
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[60] bg-background/95 backdrop-blur-sm flex flex-col items-center justify-center p-6">
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 p-2 rounded-full hover:bg-muted transition-colors"
        aria-label="Close"
      >
        <X className="h-8 w-8 text-foreground" />
      </button>
      
      <div className="w-full max-w-sm flex flex-col items-center space-y-6">
        {/* Headline */}
        <h1 className="text-xl font-serif font-semibold text-center text-foreground leading-relaxed">
          {t('rewardNoPartnerYet')}
        </h1>
        
        {/* Supporting text */}
        <p className="text-base text-muted-foreground text-center whitespace-pre-line">
          {t('partnerInquiryDesc')}
        </p>
        
        {/* CTA */}
        <Button 
          onClick={handleEmailClick}
          className="w-full h-14 text-lg gap-3"
          size="lg"
        >
          {t('partnerInquiryCta')}
          <Mail className="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
}
